import Widget from 'models/dashboard/widget'

Widget.GeochartSwitzerlandWidget = Widget.extend({
  agentIds: function () {
    return this.get('agent_ids');
  }
});

export default Widget.GeochartSwitzerlandWidget;
